import * as React from "react";

function SvgOneTrust(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 181 147"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M25.2106 87.464C25.2106 114.594 37.1582 131.197 55.3463 131.197C73.5345 131.197 84.934 114.594 84.934 87.464C84.934 58.3877 73.6441 43.5022 55.3463 43.5022C37.0486 43.5022 25.2106 58.3877 25.2106 87.464ZM110.145 87.464C110.145 122.494 85.9278 146.998 55.1271 146.998C24.3264 146.998 0 122.502 0 87.464C0 52.4258 24.6552 27.9297 55.1271 27.9297C85.599 27.9297 110.145 52.4258 110.145 87.464Z"
        fill="#55A05E"
      />
      <path
        d="M161.626 119.458C161.626 127.03 164.25 129.763 171.47 129.763L190.001 129.878V144.977H163.607C148.276 144.977 139.492 135.832 139.492 119.817V65.2289H139.47V46.7022H117.482V33.3587C118.944 33.3587 118.469 33.3358 120.471 33.2824C124.03 33.229 126.726 33.1297 128.582 32.9694C133.179 32.7099 136.248 31.7786 137.782 30.1832C139.288 28.6107 140.303 25.3282 140.852 20.3664C141.246 17.6259 141.546 14.2214 141.743 10.1374C141.94 6.08396 142.043 0.671755 142.043 0H161.626V30.5572H190.001V46.6946H161.626V119.443V119.458Z"
        fill="#55A05E"
      />
    </svg>
  );
}

export default React.forwardRef(SvgOneTrust);
